export default __webpack_public_path__ + "static/media/KE active.6da1cd1a.svg";